module.exports = __webpack_public_path__ + "img/icon_water_download_code.911795da.png";